export const ANNUAL_UPGRADE_LINK =
  "https://app.hubspot.com/payments/ZqDpjxgwgvmpch?referrer=PAYMENT_LINK";
export const MONTHLY_UPGRADE_LINK =
  "https://app.hubspot.com/payments/DZj4JtF4ZF?referrer=PAYMENT_LINK";

/** External HubSpot scheduler for the in-app "Book a call" CTAs. */
export const BOOK_A_CALL_LINK = "https://meetings.hubspot.com/jonny-law/strategy-session";

/**
 * @param annual whether the upgrade is for annual or monthly billing
 * @param email optional email to prefill on the HubSpot payment form
 */
export const upgradeLink = (annual: boolean, email?: string) => {
  const base = annual ? ANNUAL_UPGRADE_LINK : MONTHLY_UPGRADE_LINK;
  return email ? `${base}&email=${email}` : base;
};
